import { DefaultTheme } from 'styled-components';

export const generalStyle = (theme: DefaultTheme, showBorderBottom: boolean): string => {
  return `
    background-color: white;
    border-bottom-color: ${theme.color.primary.default};
    border-bottom-style: solid;
    border-bottom-width: ${showBorderBottom ? '4px' : '0'};
    display: flex;
    flex-direction: column;
    position: fixed;
    overflow: auto;
    z-index: 2147483640;
  `;
};
